import { observer } from 'mobx-react'

import { useMemo } from 'modules/core/hooks/useMemo'

import medicalLeaveUpdates from 'modules/timeoff/store/collections/medicalLeaveUpdates'
import type LeaveModel from 'modules/timeoff/store/models/Leave'

import Item from './_Item'
import Updates from './_Updates'

interface Props {
  leave: LeaveModel
  employeeId: number
  isCurrentEmployee: boolean
  employeeTimeoffPolicyId: number | null | undefined
}

const MedicalLeaveItem = ({
  leave,
  employeeId,
  isCurrentEmployee,
  employeeTimeoffPolicyId,
}: Props) => {
  const updates = useMemo(() => {
    return medicalLeaveUpdates.filter({
      leave_id: leave.attributes.id,
    })
  }, [leave.attributes.id])

  return (
    <>
      <Item
        leave={leave}
        updates={updates}
        employeeId={employeeId}
        isCurrentEmployee={isCurrentEmployee}
        employeeTimeoffPolicyId={employeeTimeoffPolicyId}
      />
      <Updates leave={leave} updates={updates} employeeId={employeeId} />
    </>
  )
}

export default observer(MedicalLeaveItem)
